"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escape_1 = __importDefault(require("lodash/escape"));
var csrf_utils_1 = __importDefault(require("../_classes/csrf_utils"));
module.exports = {
    CsrfUtils: csrf_utils_1.default,
};
// TODO: Remove when moved to TS
window.csrfGetFormToken = csrf_utils_1.default.csrfGetFormToken;
window.csrfUpdateFormToken = csrf_utils_1.default.csrfUpdateFormToken;
window.utils = {
    escape: escape_1.default,
};
